/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoViberIcon16Light } from './LogoViberIcon16Light';
import { LogoViberIcon16Regular } from './LogoViberIcon16Regular';
import { LogoViberIcon16Solid } from './LogoViberIcon16Solid';
import { LogoViberIcon20Light } from './LogoViberIcon20Light';
import { LogoViberIcon20Regular } from './LogoViberIcon20Regular';
import { LogoViberIcon20Solid } from './LogoViberIcon20Solid';
import { LogoViberIcon24Regular } from './LogoViberIcon24Regular';
import { LogoViberIcon24Solid } from './LogoViberIcon24Solid';
import { LogoViberIcon32Regular } from './LogoViberIcon32Regular';
import { LogoViberIcon64Regular } from './LogoViberIcon64Regular';
var sizes = {
    16: {
        light: LogoViberIcon16Light,
        regular: LogoViberIcon16Regular,
        solid: LogoViberIcon16Solid,
    },
    20: {
        light: LogoViberIcon20Light,
        regular: LogoViberIcon20Regular,
        solid: LogoViberIcon20Solid,
    },
    24: {
        regular: LogoViberIcon24Regular,
        solid: LogoViberIcon24Solid,
    },
    32: {
        regular: LogoViberIcon32Regular,
    },
    64: {
        regular: LogoViberIcon64Regular,
    },
};
export var LogoViberIcon = forwardRef('LogoViberIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
